/* global axios */
import ApiClient from '../ApiClient';

class AiBotIntentSetsAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/intent_sets`, { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }
}

export default AiBotIntentSetsAPI;
